import IkeOfficeLogo from '@Resources/assets/logos/ike-office-logo.svg';
import LaptopMacOutlinedIcon from '@mui/icons-material/LaptopMacOutlined';
import { Card, SvgIcon } from '@mui/material';
import React, { useState } from 'react';
import Roles from '../../HomeViewRoles';
import Styles from './ProjectCard.scss';
import ProjectCardMenu from './ProjectCardMenu';

interface IProjectCardProps {
    name: string;
    isDepartmentLinked: boolean;
    onClick: () => void;
    onDelete: () => void;
    onEditProjectName: () => void;
    id?: string;
}

const ProjectCard = (props: IProjectCardProps) => {
    const {
        name,
        isDepartmentLinked,
        onClick,
        onDelete,
        onEditProjectName,
        id,
    } = props;

    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    return (
        <Card
            id={id}
            className={Styles.pcContainer}
            onMouseLeave={() => setIsMenuVisible(false)}
            onMouseOver={() => setIsMenuVisible(true)}
            sx={{
                ':hover': {
                    backgroundColor: '#fff',
                },
            }}
        >
            <ProjectCardMenu
                id={`${id}_card-menu`}
                onDelete={onDelete}
                onEditProjectName={onEditProjectName}
                projectName={name}
                isVisible={isMenuVisible}
                onCloseCallback={() => {
                    setIsMenuVisible(false);
                    setIsMenuOpen(false);
                }}
                onOpenCallback={() => setIsMenuOpen(true)}
            />
            <div
                className={Styles.pcContent}
                onClick={onClick}
                role={Roles.projectCard}
            >
                <div className={Styles.pcContentContainer}>
                    <div
                        className={Styles.pcMediaContainer}
                        style={{
                            boxShadow:
                                isMenuVisible && !isMenuOpen
                                    ? 'inset 0 0 500px 500px rgb(0 0 0 / 3%)'
                                    : '',
                        }}
                    >
                        <div className={Styles.pcMedia}>
                            {isDepartmentLinked ? (
                                <SvgIcon
                                    inheritViewBox
                                    className={Styles.pcProjectIcon}
                                >
                                    <IkeOfficeLogo />
                                </SvgIcon>
                            ) : (
                                <LaptopMacOutlinedIcon
                                    className={Styles.pcProjectIcon}
                                />
                            )}
                        </div>
                    </div>

                    <div
                        className={Styles.pcTitleContainer}
                        style={{
                            backgroundColor: isMenuVisible ? '#fff' : '',
                            zIndex: isMenuVisible ? 10 : 1,
                        }}
                    >
                        <span
                            id={`${id}_project-title`}
                            className={Styles.pcTitle}
                        >
                            {name}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ProjectCard;
